import React from 'react';
import {object, func, bool, string} from 'prop-types';
import {createRefetchContainer, graphql} from 'react-relay';
import MobileNavSearchInput from '../MobileNavSearchInput/MobileNavSearchInput';
import MobileNavSearchResults from '../MobileNavSearchResults/MobileNavSearchResults';
import OverlayView from '../OverlayView/OverlayView';
import styles from './mobileNavSearchBar.scss';
import MobileNavAnimationSlide from '../MobileNavAnimations/MobileNavAnimationSlide';
import {createSearchLinkPath} from '../MobileNavSearchResults/mobileNavSearchResultsUtils';
import debounce from '../../../utils/debounce';

class MobileNavSearchBar extends React.Component {
    constructor() {
        super();

        this.fetchData = debounce(this.fetchData.bind(this), 300);
        this.onInput = this.onInput.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    fetchData(value = {}, callback) {
        this.props.relay.refetch({
            query: value,
            hasQuery: true
        }, null, callback);
    }

    onInput(e) {
        const { value } = e.target;

        if (value) {
            this.props.onInput(value);
            this.fetchData(value, () => {
                /**
                 * Might be possible that the user has cleared the search input by the time this callback is called.
                 * In that case we don't wan't to open the search result view.
                 */
                if (!this.props.isOpen && this.props.value) {
                    this.props.onOpen();
                }
            });
        } else {
            this.props.onClose();
        }
    }

    onSubmit(e) {
        e.preventDefault();
        const term = this.props.value;

        if (term) {
            this.props.handleNavigateAction({
                path: createSearchLinkPath({term})
            });
        }
    }

    onCloseClick() {
        this.props.onClose();
    }

    onFocus(e) {
        this.onInput(e);
    }

    render() {
        const {viewer, handleNavigateAction, isOpen, value, onAnimationEnd} = this.props;
        // Search suggestions can be undefined even after the refetch callback was fired, so we need to account for that.
        const showSearchResults = isOpen && !!viewer.searchSuggestions;

        return (
            <div className={styles.container}>
                <MobileNavSearchInput
                    showClose={showSearchResults}
                    onFocus={this.onInput}
                    onInput={this.onInput}
                    onCloseClick={this.onCloseClick}
                    onIconClick={this.onSubmit}
                    onSubmit={this.onSubmit}
                    value={value}
                />
                <MobileNavAnimationSlide
                    in={showSearchResults}
                    appear="left"
                    leave="left"
                    onAnimationEnd={onAnimationEnd}
                    scrollLock
                >
                    <OverlayView className={styles.overlay}>
                        <MobileNavSearchResults
                            handleNavigateAction={handleNavigateAction}
                            searchSuggestions={viewer.searchSuggestions}
                        />
                    </OverlayView>
                </MobileNavAnimationSlide>
            </div>
        );
    }
}

MobileNavSearchBar.propTypes = {
    viewer: object.isRequired,
    relay: object.isRequired,
    isOpen: bool,
    value: string,
    handleNavigateAction: func.isRequired,
    onAnimationEnd: func.isRequired,
    onClose: func.isRequired,
    onOpen: func.isRequired,
    onInput: func.isRequired
};

export default createRefetchContainer(
    MobileNavSearchBar,
    {
        viewer: graphql.experimental`
            fragment MobileNavSearchBar_viewer on Viewer
            @argumentDefinitions(
                query: {type: "String!", defaultValue: ""}
                hasQuery: {type: "Boolean!", defaultValue: false}
            ) {
                searchSuggestions(query: $query, includeTypes: ["POPULAR", "SELLER"]) @include(if: $hasQuery) {
                    ...MobileNavSearchResults_searchSuggestions
                }
            }
        `
    },
    graphql.experimental`
        query MobileNavSearchBarViewerQuery (
            $query: String = "",
            $hasQuery: Boolean!
        ) {
            viewer {
                ...MobileNavSearchBar_viewer @arguments (query: $query, hasQuery: $hasQuery)
            }
        }
    `
);



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavSearchBar/MobileNavSearchBar.jsx